import { privateRequest, type ApiResponse } from "../axios";

export interface LeavePolicyRuleDto {
  Id?: number;
  LeavePolicyId?: number;
  LeaveTypeId: number;
  LeaveTypeName?: string;
  EntitlementCount: number;
  EntitlementFrequency: number; // 1 = Annual, 2 = Monthly, 3 = Quarterly, 4 = Immediate
  AccrualFrequency: number; // 1 = Annual, 2 = Monthly, 3 = Quarterly, 4 = Immediate
  CarryForwardLimit: number;
  IsExpiryEnabled?: boolean;
  ExpiryDays?: number;
  AllowNegativeBalance: boolean;
  MaxNegativeBalanceDays?: number;
  NoticeDaysRequired: number;
  MaxDaysPerRequest: number;
  AllowEncashment: boolean;
  EncashmentLimitDays?: number;
  IsActive?: boolean;
}

export interface SaveLeavePolicyDto {
  Id?: number;
  PolicyName: string;
  Description?: string;
  IsActive?: boolean;
  EffectiveFrom?: string;
  EffectiveTo?: string | null;
  AssignmentType: number;
  UserId?: number | null;
  RoleId?: number | null;
  DepartmentId?: number | null;
  DesignationId?: number | null;
  ComplianceProfileId?: number | null;
  ComplianceProfileName?: string;
  Rules: LeavePolicyRuleDto[];
}

export interface LeavePolicyDto {
  Id: number;
  PolicyName: string;
  Description: string;
  IsActive: boolean;
  EffectiveFrom?: string;
  EffectiveTo?: string | null;
  CreatedDate?: string;
  ModifiedDate?: string;
  RulesCount?: number;
  AssignmentType?: number;
  UserId?: number | null;
  RoleId?: number | null;
  DepartmentId?: number | null;
  DesignationId?: number | null;
  ComplianceProfileId?: number | null;
  ComplianceProfileName?: string;
  ComplianceStatus?: "Compliant" | "Non-Compliant" | "Not Assigned";
  DepartmentName?: string;
  DesignationName?: string;
  RoleName?: string;
  UserName?: string;
  EmployeeName?: string;
  Rules?: LeavePolicyRuleDto[];
}

const ENDPOINTS = {
  LEAVE_POLICY: "api/LeavePolicy",
};

const getLeavePolicies = async (): Promise<ApiResponse<LeavePolicyDto[]>> => {
  const res = await privateRequest.get<ApiResponse<LeavePolicyDto[]>>(ENDPOINTS.LEAVE_POLICY);
  return res.data;
};

const createLeavePolicy = async (payload: SaveLeavePolicyDto): Promise<ApiResponse<any>> => {
  const res = await privateRequest.post<ApiResponse<any>>(ENDPOINTS.LEAVE_POLICY, payload);
  return res.data;
};

const updateLeavePolicy = async (payload: SaveLeavePolicyDto): Promise<ApiResponse<any>> => {
  const res = await privateRequest.put<ApiResponse<any>>(ENDPOINTS.LEAVE_POLICY, payload);
  return res.data;
};

const toggleLeavePolicyStatus = async (id: number): Promise<ApiResponse<any>> => {
  const res = await privateRequest.post<ApiResponse<any>>(`${ENDPOINTS.LEAVE_POLICY}/${id}/Toggle`);
  return res.data;
};

const LeavePolicyService = {
  getLeavePolicies,
  createLeavePolicy,
  updateLeavePolicy,
  toggleLeavePolicyStatus,
};

export default LeavePolicyService;
